import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-layout__container" }
const _hoisted_2 = { class: "filter-layout__container--content" }
const _hoisted_3 = { class: "page__issue-tracker" }
const _hoisted_4 = {
  key: 0,
  class: "empty-placeholder row"
}
const _hoisted_5 = { class: "hero-img" }
const _hoisted_6 = {
  key: 1,
  class: "items-list__container"
}
const _hoisted_7 = { class: "items-list__nav" }
const _hoisted_8 = {
  key: 0,
  class: "items-list__list"
}
const _hoisted_9 = { class: "items-list__item-catalogue" }
const _hoisted_10 = { class: "items-list__item-title" }
const _hoisted_11 = {
  key: 2,
  class: "empty-placeholder"
}
const _hoisted_12 = { class: "hero-img space-v4" }
const _hoisted_13 = {
  key: 3,
  class: "details-view__container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock($setup["Page"], {
    parent: $setup.currentParent,
    "hide-nav": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!$setup.Tracker.drafts.total && !$setup.Tracker.issues.total)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", null, [
                      _createElementVNode("span", null, "You're all clear 👌"),
                      _createElementVNode("br"),
                      _createElementVNode("span", null, "No pending drafts or order issues at the moment")
                    ], -1)),
                    _createVNode($setup["AllClearImg"]),
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          dense: "",
                          rounded: "",
                          style: {"padding":"6px 12px"}
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("span", null, "To Orders Dashboard ", -1),
                            _createElementVNode("span", {
                              class: "t-icon",
                              style: {"text-transform":"lowercase","vertical-align":"bottom"}
                            }, "g", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode($setup["TabNav"], {
                      active: $setup.state.view,
                      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.view) = $event)),
                      views: $setup.views,
                      "big-nav": "",
                      onDeactivate: _cache[1] || (_cache[1] = ($event: any) => ($setup.state.active = null))
                    }, null, 8, ["active", "views"])
                  ]),
                  ($setup.state.view)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode($setup["SelectableList"], {
                          items: $setup.Tracker[$setup.state.view.id]?.value
                        }, {
                          item: _withCtx(({ activate, item, ...$props }) => [
                            _createVNode($setup["SelectableItem"], _mergeProps({ class: "items-list__item" }, $props, {
                              onSelect: ($event: any) => ($setup.debouncedActivateItem(activate, $setup.edit, $event))
                            }), {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, _toDisplayString($setup.Tracker.dict.catalogue[item.catalogue || item.raw?.catalogue]?.name), 1),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(item.reference || `${item.meta?.reference}${item.meta?.reference ? ' — ' : ''}${item.id}`), 1)
                              ]),
                              _: 2
                            }, 1040, ["onSelect"])
                          ]),
                          _: 1
                        }, 8, ["items"])
                      ]))
                    : _createCommentVNode("", true)
                ])),
            (!$setup.isMobile && !(!$setup.Tracker.drafts.total && !$setup.Tracker.issues.total) && !($setup.state.active && $setup.state.view?.id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "spacer space-v4" }, [
                    _createElementVNode("br")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode($setup["ChooseItem"]),
                    _cache[8] || (_cache[8] = _createElementVNode("h5", null, [
                      _createElementVNode("br"),
                      _createElementVNode("span", null, "Select an order to get started")
                    ], -1))
                  ])
                ]))
              : ($setup.state.active && $setup.state.view?.id && ($setup.Tracker.drafts.total || $setup.Tracker.issues.total))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode($setup["ControllableView"], {
                      "model-value": $setup.state.view?.id,
                      views: $setup.views
                    }, {
                      drafts: _withCtx(() => [
                        _createVNode($setup["DraftEditor"], {
                          modelValue: $setup.Tracker.dict.draft.value[$setup.state.active],
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.Tracker.dict.draft.value[$setup.state.active]) = $event)),
                          link: $setup.link,
                          onIgnore: $setup.Tracker.drafts.ignore,
                          onCommit: $setup.Tracker.drafts.commit,
                          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.state.active = null))
                        }, null, 8, ["modelValue", "link", "onIgnore", "onCommit"])
                      ]),
                      issues: _withCtx(() => [
                        _createVNode($setup["IssueEditor"], {
                          modelValue: $setup.Tracker.dict.issue.value[$setup.state.active],
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.Tracker.dict.issue.value[$setup.state.active]) = $event)),
                          link: $setup.link,
                          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.state.active = null)),
                          onResolve: $setup.Tracker.issues.resolve,
                          onReset: $setup.Tracker.issues.resetOrder,
                          onNoteAdded: $setup.Tracker.issues.addNote
                        }, null, 8, ["modelValue", "link", "onResolve", "onReset", "onNoteAdded"])
                      ]),
                      _: 1
                    }, 8, ["model-value", "views"])
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["parent"]))
}